import React, { Component } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Grid, Button, Popup, Header, Icon } from "semantic-ui-react";
import AdSense from "react-adsense";
import MovingText from "./ScrollingText";
import SponsorBanner from "./SponsorBanner";
class SignedInAd extends Component {
    render() {
        const { sponsor_ad } = this.props;
        const links = (
                <Grid columns={16} stackable={false}
                    style={{ minHeight: 60, paddingTop: 2, backgroundColor: 'var(--secondary)', paddingLeft: 15 }}>

                    {this.props.show_ads &&
                        <Grid.Column style={{ backgroundColor: 'inherited' }} width={10} key='adsense-internal' textAlign="right">
                            <>
                                <AdSense.Google
                                    client='ca-pub-4274068129397983'
                                    slot='1035864869'
                                    style={{ width: 600, height: 70, float: 'right' }}
                                    format=''
                                />
                            </>
                        </Grid.Column>
                    }
                    {this.props.restrict_save &&
                        <Grid.Column width={4} key='moving_text' floated='right' >
                            <MovingText texts={this.props.texts} />
                        </Grid.Column>
                    }

                </Grid>
        );
        if (!sponsor_ad) {
            return <div id="internal-ad-off">{links}</div>;
        }
        return (
            <div id="internal-ad-off" className="sponsor-row" style={{ backgroundColor: 'var(--secondary)' }}>
                <div className="sponsor-row__content">{links}</div>
                <SponsorBanner sponsor_ad={sponsor_ad} l={this.props.l} onLayoutChange={this.props.onSponsorLayoutChange} />
            </div>
        );
    }
}

export default SignedInAd;
